'use client';

import { Globe, Smartphone, Database, Cloud } from 'lucide-react';
import { motion } from 'framer-motion';
import ServiceCard from './ServiceCard';

const services = [
  {
    icon: Globe,
    title: 'Web Development',
    description:
      'Modern, responsive web applications built with cutting-edge technologies for optimal performance and user experience.',
    features: ['Responsive Design', 'SEO Optimized', 'Fast Loading', 'Cross-browser'],
    techStack: ['React', 'Next.js'],
  },
  {
    icon: Smartphone,
    title: 'Mobile Apps',
    description:
      'Native and cross-platform mobile applications that deliver seamless experiences across all devices.',
    features: ['Cross-platform', 'Offline Support', 'Push Notifications', 'App Store Ready'],
    techStack: ['Flutter'],
  },
  {
    icon: Database,
    title: 'Database Design',
    description:
      'Scalable database architectures optimized for performance, reliability, and data integrity.',
    features: ['Schema Design', 'Query Optimization', 'Data Migration', 'Backup Strategy'],
    techStack: ['PostgreSQL', 'MongoDB', 'Redis'],
  },
  {
    icon: Cloud,
    title: 'Cloud Infrastructure',
    description: 'Deploy and manage scalable cloud solutions with automated CI/CD pipelines.',
    features: ['Auto Scaling', 'Load Balancing', 'Monitoring', 'Disaster Recovery'],
    techStack: ['AWS', 'Docker', 'Kubernetes'],
  },
];

const ServicesSection = () => {
  return (
    <section id="services" className="section-pad section-rule relative z-10 bg-background">
      <div className="mx-auto max-w-7xl">
        <motion.div
          className="mb-10 max-w-2xl"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-80px' }}
          transition={{ duration: 0.6 }}
        >
          <h2 className="mb-3 font-display text-2xl font-bold tracking-tight text-foreground sm:mb-4 sm:text-4xl lg:text-5xl">
            Our services
          </h2>
          <p className="text-sm leading-relaxed text-text-secondary sm:text-lg">
            Professional capabilities designed to help your product ship and scale.
          </p>
        </motion.div>

        <div>
          {services.map((service, index) => (
            <ServiceCard key={service.title} {...service} delay={index * 0.05} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
